<template>
    <div class="v-alert create-ad w-1100" style="top: 10px;">
        <header><p>Create Ad</p><div class="x" @click="$emit('emit',{ action: 'exit' })"></div></header>
        <div class="edit-ad-container">
            <div class="left">
                <div :class="['background',{ selected: selectFront }]" @click="upload('src',$event)">
                    <div class="ad-box" style="width: 414px;">
                        <img v-if="ad.src" :src="ad.src" width="100%" class="upload" />
                        <p v-else class="btn upload" style="width: 280px;transform: scale(1.445) translateY(150px);transform-origin: 0px 0px;">UPLOAD AD FRONT IMAGE</p>
                        <div v-if="ad.src" class="ad-btns">
                            <div @mousedown="startMove(btn,$event)" @click="selectBtn(btn)" v-for="(btn,i) in ad.btns.filter(b => !b.reverse)" :key="i" :class="['ad-btn',{ selected: btn.selected },'type-'+btn.content.action]" :style="btn.content.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'">
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" :style="btn.content.style" />
                                <video v-if="btn.type == 'video'" :id="btn.code" :src="btn.content.mov"  controls="true" width="100%" height="100%"></video>
                                <img v-if="btn.type == 'qr'" src="https://api.survey-vip.com/qr?id=httpsasdfsadfsadfasdfsomerandomdataorother" width="100%" />
                                <div v-if="btn.type == 'video'" style="position: absolute;top:0px;left:0px;width: 100%;height: 100%;"></div>
                            </div>
                        </div>                        
                    </div>  
                </div>
                <!-- <p class="btn" style="float: left;width: 190px;margin-left: 50px;" @click="select('front')">SELECT FRONT FACE</p> -->
                <div :class="['backface',{ selected: selectBack }]" @click="upload('backface',$event)">
                    <div class="ad-box" style="width: 414px;">
                        <img v-if="ad.backface" :src="ad.backface" width="100%" class="upload" />
                        <p v-else class="btn upload" style="width: 280px;transform: scale(1.445) translateY(150px);transform-origin: 0px 0px;">UPLOAD AD BACK IMAGE</p> 
                        <div v-if="ad.backface" class="ad-btns">
                            <div @mousedown="startMove(btn,$event)" @click="selectBtn(btn)" v-for="(btn,i) in ad.btns.filter(b => b.reverse)" :key="i" :class="['ad-btn',{ selected: btn.selected },'type-'+btn.content.action]" :style="btn.content.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'">
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" :style="btn.content.style" />
                                <video :id="btn.code" v-if="btn.type == 'video'"  :src="btn.content.mov"  controls="true" width="100%" height="100%"></video>
                                <img v-if="btn.type == 'qr'" src="https://api.survey-vip.com/qr?id=httpsasdfsadfsadfasdfsomerandomdataorother" width="100%" />
                                <div v-if="btn.type == 'video'" style="position: absolute;top:0px;left:0px;width: 100%;height: 100%;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <p class="btn" style="float: left;width: 190px;margin-left: 50px;" @click="select('back')">SELECT BACK FACE</p> -->
            </div>
            <div class="right">
                <div class="label w-50" style="height:0px">
                    <p>Title</p>
                    <input v-model="ad.title" />
                </div>
                <div class="label w-50">
                    <p>Category</p>
                    <select v-model="ad.cat"><option v-for="cat in cats">{{ cat }}</option></select>
                </div>
                <div class="label w-50" style="margin-bottom: 0px;">
                    <p>Bottomless</p>
                    <input type="checkbox" v-model="ad.isBottomless" @change="updateBottomless(ad,$event)" />
                    <select class="bottomless-select" v-if="!ad.redeemAd" v-model="ad.bottomless" @change="updateAdBottomLess(ad,ad.bottomless)"><option v-for="bottom in bottomless">{{ bottom }}</option></select>
                </div>
                <div class="label w-50">
                    <p>Expire Ad</p>
                    <input v-model="ad.expireAd" type="checkbox" style="margin: 4px 0px;float: left;" @change="checkExpireAd" />
                    <p style="width: calc(100% - 51px);height:30px;border: 1px solid black;background-color:whitesmoke;line-height: 30px;padding: 0px 5px;position: relative;left:33px" @click="setExpire = true">{{ ad.u_expires }}</p>
                </div>
                <div class="label w-50">
                    <p>Button Type</p>
                    <select v-model="btnType"><option v-for="(btn,i) in types" :key="i">{{ btn.type }}</option></select>
                </div>
                <div class="label w-50">
                    <p v-if="btnType" class="btn" style="width: 177px;margin: 20px 0px 0px 0px" @click="addButton('front',btnType)">add {{ btnType }} front</p>
                    <p v-if="btnType" class="btn" style="width: 177px;margin: 20px 0px 0px 20px" @click="addButton('back',btnType)">add {{ btnType }} back</p>
                </div>
                <div class="label w-100" v-if="ad.btns.length > 0">
                    <p>Buttons</p>
                    <div class="btn-list">
                        <p>Type</p>
                        <p>Side</p>
                        <p>Left</p>
                        <p>Top</p>
                        <p>Width</p>
                        <p>Height</p>
                    </div>
                    <div v-for="(btn,i) in ad.btns" :key="i" @keyup="updateBtn(btn)">
                        <div v-if="!btn.selected" class="btn-list">
                            <p class="td-ulb" @click="selectBtn(btn)">{{ btn.type }}</p><p>{{ btn.reverse ? 'BACK' : 'FRONT' }}</p><p>{{ btn.content.left }}</p><p>{{ btn.content.top }}</p><p>{{ btn.content.width }}</p><p>{{ btn.content.height }}</p><div class="x" @click="ad.btns = ad.btns.filter(b => b != btn)"></div>
                        </div>
                        <div v-if="btn.selected" class="btn-list btn-selected">
                            <p class="td-ulb" @click="selectBtn(btn)">{{ btn.type }}</p>
                            <p>{{ btn.reverse ? 'BACK' : 'FRONT' }}</p>
                            <input v-model.number="btn.content.left" @keydown="updateKeyBtn(btn,'left',$event)" />
                            <input v-model.number="btn.content.top" @keydown="updateKeyBtn(btn,'top',$event)"/>
                            <input v-model.number="btn.content.width" @keydown="updateKeyBtn(btn,'width',$event)"/>
                            <input v-model.number="btn.content.height" @keydown="updateKeyBtn(btn,'height',$event)"/>
                            <div class="x" @click="ad.btns = ad.btns.filter(b => b != btn)"></div>
                        </div>
                        <div v-if="btn.selected">
                            <div class="label" v-if="btn.type == 'video'" style="margin-left:0px;margin-top:0px">
                                <p>.mp4 URL</p>
                                <input v-model="btn.content.mov" placeholder="https://..."/>
                            </div>
                            <div class="label" v-if="btn.type == 'gif'" style="margin-left:0px;margin-top:0px">
                                <p>.gif URL</p>
                                <input v-model="btn.content.gif" placeholder="https://..."/>
                            </div>
                            <div class="label" v-if="btn.type == 'terms'" style="margin-left:0px;margin-top:0px">
                                <p class="btn" @click="editTerms(btn)">EDIT TERMS</p>
                                <p></p>
                            </div>
                            <div class="label" v-if="btn.type == 'link'" style="margin-left:0px;margin-top:0px">
                                <p>Link URL</p>
                                <input v-model="btn.content.value" placeholder="https://..."/>
                            </div>                              
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns" style="width: 1100px">
                <p class="btn" @click="save(ad)">SAVE</p>
            </div>
        </div>

        <div v-if="downloading" class="fixed-scroller downloading" @click="downloading = false" style="width:100%">
            <div class="bar">
                <div class="progress" :style="{ width: 'calc('+((downloading.progress / downloading.count) * 100 )+'% - 10px)' }"></div>
            </div>
        </div>
        <div v-if="setExpire" class="v-alert">
            <header><p>Set Ad Expire</p><div class="x" @click="setExpire = false"></div></header>
            <div class="label">
                <p style="width:100px">Expires</p>
                <div class="date-time-box" @change="changeDate">
                    <div class="label w-50">
                        <p>Hr</p>
                        <select v-model="hour"><option v-for="Hr in hours">{{ Hr }}</option></select>
                    </div>
                    <div class="label w-50">
                        <p>Min</p>
                        <select v-model="minute"><option v-for="Min in minutes">{{ Min }}</option></select>
                    </div>
                </div> 
                <div class="date-time-box" @change="changeDate"> 
                    <div class="label w-33">
                        <p>Day</p>
                        <select v-model="day"><option v-for="Day in days">{{ Day }}</option></select>
                    </div>    
                    <div class="label w-33">
                        <p>Mth</p>
                        <select v-model="month"><option v-for="Month in months">{{ Month }}</option></select>
                    </div> 
                    <div class="label w-33">
                        <p>Year</p>
                        <select v-model="year"><option v-for="Year in years">{{ Year }}</option></select>
                    </div>                                       
                </div>
            </div>
            <div class="btns">
                <p class="btn" @click="setExpiryDate">save date</p>
            </div>
        </div>
        <Quill v-if="quill" :item="quill" @emit="emit" />
        <div v-if="previewHTML" class="previewHTML ql-snow" style="border:1px solid #c0c0c0">
            <header><p>Preview</p><div class="x" @click="previewHTML = false"></div></header>
            <div class="ql-editor">            
                <div v-html="previewHTML">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Alert from '@/utils/Alert.js';
import UploadFile from '@/utils/UploadFile.js'
import postMinify from '@/utils/postMinify.js'
import WebSoc from '@/utils/WebSoc.js'
import { format } from 'date-fns' 
import Quill from '@/components/Quill.vue'
//import { VueEditor, Quill } from 'vue2-editor'

export default {
    props: ['item'],
    components: {
        Quill,
        //VueEditor
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        currentOffers () { return this.$store.state.currentOffers }
    },
    data () { 
        return {
            selectFront: false,
            selectBack: false,
            setExpire: false,
            btnType: '',
            types: [
                //{ type: 'back', selected: false, content: { style: '', action: 'back', top: 0, left: 0, width: 90, height: 80, value: '', html: [0,0].map(c => '<div></div>').join('') } },
                //{ type: 'hamburger', selected: false, content: { style: '', action: 'ham', top: 0, left: 0, width: 90, height: 80, value: '', html: [0,0,0].map(c => '<div></div>').join('') } },
                //{ type: 'next', selected: false, content: { style: '', action: 'next', value: '', top: 285, left: 40, width: 334, height: 65 } },
                //{ type: 'step', selected: false,  content: { style: '', action: 'step', value: '', top: 285, left: 40, width: 334, height: 65 } },
                //{ type: 'input', selected: false, content: { style: '', border: false, borderColor: '#ffffff', action: 'input', textarea: true, top: 285, left: 40, width: 334, height: 65, field: '', value: '', placeholder: 'Write your answer here...', error: '' } },
                //{ type: 'select', selected: false, content: { style: '', action: 'select', value: '', options: '', top: 300, left: 40, width: 334, height: 65 } },
                { type: 'link', selected: false,  content: { style: '', action: 'link', value: '', top: 300, left: 40, width: 334, height: 65 } },
                //{ type: 'location', selected: false, content: { style: '', action: 'location', options: '', value: 'Store', top: 300, left: 40, width: 344, height: 65 } },
                //{ type: 'qr', selected: false, content: { style: '', action: 'qr', options: '', value: '', top: 110, left: 110, width: 180, height: 180 } },
                { type: 'terms',  content: { style: '', action: 'terms', value: '', top: 285, left: 40, width: 334, height: 65 } },
                { type: 'rotate', selected: false, content: { style: '', action: 'rotate', top: 376, left: 29, width: 350, height: 90, value: '' }, contentRotate: { style: '', action: 'rotate', top: 0, left: 0, width: 410, height: 90, value: '' } },
                { type: 'qr', selected: false, content: { style: '', action: 'qr', top: 110, left: 110, width: 180, height: 180, value: '' } },
                { type: 'comp', selected: false, content: { style: '', action: 'comp', value: '', top: 285, left: 40, width: 334, height: 65 } },
                { type: 'gif', selected: false, content: { style: '', action: 'gif', top: 90, left: 65, width: 280, height: 280, value: '', gif: '' } },
                { type: 'video', selected: false, fixed: true, content: { style: '', action: 'video', top: 100, left: 17, width: 380, height: 220, value: '', mov: '' } },
                //{ type: 'slider', seleted: false, content: { style: '', action: 'slider', top: 40, left: 20, width: 390, height: 100, value: '', init: 0, step: 1, min: 0, max: 11 } },
                //{ type: 'checkbox', selected: false, content: { style: '', action: 'checkbox', top: 40, left: 20, width: 334, height: 65, background: '' } },
                //{ type: 'stars', selected: false, content: { style: '', action: 'stars', top: 300, left: 40, width: 380, height: 76, background: '', auto: false } },
                //{ type: 'image', selected: false, content: { style: '', action: 'image', top: 300, left: 30, width: 320, height: 320, background: '' } },
                //{ type: 'slider-score', selected: false, content: { style: '', action: 'slider-score', top: 210, left: 30, width: 354, height: 120, background: '' } },
                //{ type: 'quiz-score', selected: false, content: { style: '', action: 'quiz-score', top: 200, left: 30, width: 320, height: 320, background: '' } },
                //{ type: 'quiz-result', selected: false, content: { style: '', action: 'quiz-result', top: 200, left: 100, width: 210, height: 210, background: '', img: '' } }  
            ],
            cats: [],
            hours: new Array(24).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            minutes: new Array(60).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            days: new Array(31).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            months: new Array(12).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            years: new Array(15).fill(true).map((_,i) => (new Date().getFullYear()-2000)+i),
            hour: '00',
            minute: '00',
            day: '01',
            month: '01',
            bottomless: [
                'immediate',
                '1 Hour',
                '1 day',
                'Monday',
                'Friday',
                '7 days',
                '1st of Month',
                '6 Months',
                '12 Months'
            ],
            year: (new Date().getFullYear() - 2000)+'',
            ad: {
                rotated: false,
                btns: [],
                bottomless: 'immediate',
                removed: false,
                redeemAd: true,
                expireAd: false,
                u_expires: '',
                expires: false,
                redeemCount: 0,
                qtySent: 0,
                clicked: 0,
                issued: 0,
                title: '',
                field: '',
                tag: '',
                src: '',
                backface: '',
                cat: '',
                unique: {},
                sent: [],
                entries: [],
                dRotate: {},
                dSent: {},
                dRedeem: {},
                dSpin: {},
                dRotate: {},
                dLink: {}  
            },
            downloading: false,
            currentItem: false,
            quill: false,
            html: false,
            previewHTML: false,
            previewContent: ''
        }
    },    
    created () {
        var item = this.item;
        if ( item ) {
            console.log('created');
            console.log('item.redeemAd',item.redeemAd);
            console.log('item.bottomless',item.bottomless);
        
            var currentItem = JSON.parse(JSON.stringify(item));
            currentItem.bottomless = currentItem.bottomless || 'immediate';
            currentItem.redeemAd = currentItem.redeemAd || false;
            currentItem.isBottomless = !currentItem.redeemAd;
            currentItem.cat = currentItem.cat || '';
            currentItem.expires = currentItem.expires || false;
            currentItem.u_expires = currentItem.u_expires || '';
            currentItem.redeemAd = currentItem.redeemAd || false;
            currentItem.expireAd = currentItem.expireAd || false;
            currentItem.src = currentItem.background;
            currentItem.backface = currentItem.backFaceImage;
            this.ad = JSON.parse(JSON.stringify(currentItem));
            this.currentItem = currentItem;
            console.log('currentItem',JSON.parse(JSON.stringify(currentItem)));
            console.log('currentItem.isBottomless',currentItem.isBottomless);
        }
    },
    mounted () {

        this.getCats();
        var ad = this.ad;
        this.expires = ad.expires;
        if ( ad.expires > 0 ) {
            var date = new Date(ad.expires);
            this.hour = adZ(date.getHours());
            this.minute = adZ(date.getMinutes());
            this.day = adZ(date.getDate());
            this.month = adZ(date.getMonth() + 1);
            this.year = adZ(date.getFullYear() - 2000);
        }

        function adZ(num) { return (num < 9 ? '0' : '')+num }
    },
    methods: {
        updateBottomless ( ad, e ) {
            ad.redeemAd = !ad.redeemAd;
            console.log('ad.redeemAd',ad.redeemAd);
        },
        updateAdBottomLess ( ad, bottomless ) {
            console.log('updateAd Bottomless',bottomless,ad.bottomless);
        },
        handleImageAdded ( file, Editor, cursorLocation, resetUploader ) {
            console.log('imageAdded',file);
        },
        handleTextChange ( delta, oldDelta, source) {
            console.log('delta',delta);
        },
        saveQuill () {
            console.log('this.quill',this.quill);
            this.quill = false;
        },
        editTerms ( btn ) {

            const saveChanges = ( item ) => {
                this.quill = false;
                WebSoc.SEND({ t: 'updateQuill', data: item },(resp) => {
                    if ( resp._id ) { btn.terms_id = resp._id }
                });
            }

            if ( btn.terms_id ) {
                WebSoc.SEND({ t: 'getQuill', data: { _id: btn.terms_id } },quill => {
                    quill.save = saveChanges;
                    this.quill = quill;
                })
            } else {
                this.quill = {
                    save: saveChanges,
                    html: '<p>Edit you page here</p>',
                }
            }
            
        },
        emit ( data ) {
            if ( data.action == 'exit' ) {
                this.quill = false;
            }
            if ( data.action == 'updateHTML' ) {
                this.previewContent = data.HTML;
            }
            if ( data.action == 'showPreview' ) {
                this.previewHTML = this.previewContent;
            }
        },
        save ( ad ) {
            
            if ( ad.cat == 'No Category' ) { ad.cat = '' }
            if ( !ad.title ) return Alert.message('Each ad must have a title');

            this.progress = {};

            if ( this.currentItem ) {
                
                var item = this.currentItem;
                
                ad.background = ad.src;
                ad.backFaceImage = ad.backface;
                ad.cat == 'No Category' && ( ad.cat = '' );
                var update = Object.keys(item).reduce((p,key) => {
                    if ( JSON.stringify(item[key]) != JSON.stringify(ad[key]) ) p[key] = ad[key];
                    return p
                },{});
                this.$emit('emit',{ action: 'exit' });
                if ( Object.keys(update).length == 0 ) return;
                update.pending = 0;
                //console.log('update',update);

                return WebSoc.SEND('updateCampaignAd',{ campaign_id: item.campaign_id, ad_id: ad.ad_id, code: ad.code, update, client_id: this.client_id },resp => {
                    //console.log('updated')
                })
            }

            WebSoc.SEND('saveCampaignAd',{ campaign_id: this.currentOffers._id, ad: ad, client_id: this.client_id },resp => {
                console.log('resp',resp);
                this.progress = false;
                this.$emit('emit',{ action: 'exit' });
            });
        },
        startMove ( btn, e ) {
            this.selectBtn(btn);
            var clientX = e.clientX;
            var clientY = e.clientY;
            var left = btn.content.left;
            var top = btn.content.top;
            var width = btn.content.width;
            var height = btn.content.height;

            var adBox = e.target.parentElement.parentElement

            const mouseMove = e => {
                e.preventDefault();
                var Top = top + ( ( ( e.clientY ) - clientY ) / 0.7 )
                if ( Top < 0 ) Top = 0;
                if ( Top + height > 498 ) { Top = 498 - height } 
                btn.content.top = parseInt(Top);
                var Left = left + ( ( ( e.clientX ) - clientX ) / 0.7 )
                if ( Left < 0 ) Left = 0;
                if ( Left + width > 412 ) { Left = 412 - width }
                btn.content.left = parseInt(Left);
                this.updateBtn(btn);
            }

            const mouseUp = e => {
                adBox.removeEventListener('mouseleave',mouseUp);
                adBox.removeEventListener('mouseup',mouseUp);
                this.$el.removeEventListener('mousemove',mouseMove);
            }
           

            adBox.addEventListener('mouseleave',mouseUp);
            adBox.addEventListener('mouseup',mouseUp);
            this.$el.addEventListener('mousemove',mouseMove);
        

        },
        setExpiryDate () {
            this.ad.expires = this.expires;
            this.ad.u_expires = format(this.expires,'dd/MM/yy HH:mm');
            this.setExpire = false;
        },
        changeDate () {
            var { hour, minute, day, month, year } = this;
            this.expires = new Date(2000 + parseInt(year),month-1,parseInt(day),parseInt(hour),parseInt(minute)).valueOf();
        },
        checkExpireAd () {
            if ( this.ad.expireAd ) {
                this.setExpire = true;
            } else {
                this.ad.u_expires = '';
                this.ad.expires = false;
            }
        },
        updateKeyBtn ( btn, field, e ) {
            var dir = [40,38].indexOf(e.keyCode);
            if ( dir == -1 ) return;
            e.preventDefault();
            if ( dir == 0 ) dir = -1;
            btn.content[field] += dir;
            this.updateBtn ( btn );
        },
        select ( type ) {
            switch ( type ) {
                case 'front':
                    this.selectFront = true;
                    this.selectBack = false;
                    break;
                case 'back':
                    this.selectBack = true;
                    this.selectFront = false;
            }  
        },
        upload ( type, e ) {
            if ( !e.target.classList.contains('upload') ) return console.log('!upload type',type);
            this.select(type);
            UploadFile(result => {
                this.downloading = { count: 100, progress: 0 };
                postMinify(result.result,resp => {
                    if ( resp.size ) return console.log('resp.size',resp.size);
                    if ( resp.progress ) { this.downloading.count = resp.progress.total; this.downloading.progress = resp.progress.progress; return; }
                    if ( resp.url ) this.downloading = false;
                    if ( resp.url ) this.ad[type] = resp.url;
                    this.select(type == 'src' ? 'front' : 'back');
                })
            })
        },
        addButton ( side, type ) {
            var btn = JSON.parse(JSON.stringify(this.types.find(b => b.type == type)));
            btn.reverse = side == 'back';
            this.updateBtn(btn);
            this.ad.btns.push(btn);
            this.ad.btns.forEach(b => b.selected = b == btn);
        },
        updateBtn ( btn ) {
            var content = btn.content;
                content.style = ['top','left','width','height'].map(f => f+':'+content[f]+'px').join(';');
        }, 
        selectBtn ( btn ) {
            this.ad.btns.forEach(b => b.selected = b == btn);
        },
        btnClick ( btn ) {
            console.log('btnClick',btn);
        },
        getCats () {
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { adCats: 1 } },client => {
                this.ad.cat = this.ad.cat || 'No Category';
                this.cats = ['No Category'].concat(client.adCats);
            });
        }
    }
}

</script>

<style lang="scss">

@import "~vue2-editor/dist/vue2-editor.css";
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.snow.css';

.v-alert .label .bottomless-select {
    width: 120px;
    margin: 0px;
    position: relative;
    top: -7px;
    left: 40px;
}

.previewHTML {
    position: absolute;
    top: 30px;
    right: calc(50% - 212px);
    width:414px;
    height: 660px;
    background-color: white;
    z-index: 100;
    .ql-editor {
        overflow-y: scroll;
    }
}
.quillWrapper {
    background-color:rgba(200,0,0,0.3);
    height: 600px;
}

.vue-editor-container {
    height: 600px;
    width: calc(100% - 10px);
    margin: 5px;
}

.v-alert.create-ad {
   .ad-box {
       transform-origin: 0px 0px;
       transform: scale(0.675);
        .ad-btns {
            position: absolute;
            top: 0px;
            left: 0px;
            transform-origin: 0px;
            .ad-btn {
                position: absolute;
                background-color: rgba(200,0,0,0.4);
                &.selected {
                    transform: translate(-1px,-1px);
                    border: 1px solid red;
                    background-color: rgba(200,0,0,0.6);
                }
            }
        }
   } 
   .edit-ad-container {
       display: grid;
       grid-template-columns: 300px 1fr;
       .background,.backface {
           width: 280px;
           height: 338px;
           border: 1px solid #c0c0c0;
           margin: 5px;
           float: left;
           &.selected-xxx {
               border: 5px solid red;
               transform: translate(-5px,5px);
           }
           > p.btn { width: calc(100% - 10px); margin-top: calc(50% - 15px);  }
       }
       .btn-list {
           display: grid;
           grid-template-columns: 90px 90px 100px 100px 100px 100px 100px 60px;
           margin-top: 10px;
           position: relative;
           input {
               position: relative;
               left: -6px;
               top: -5px;
           }
           .x {
               position: relative;
               transform: scale(0.5) translateY(10px);
               height: 0px;
           }
       }
   }
}

</style>